import {Component, OnInit} from '@angular/core';
import {Router, RouterLink} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {environment} from "../../environments/environment";
import {DELIVERY_TIME_TEXT} from "../../services/util/constants";

/** What the checkout hands over when it navigates here - the cart is already empty by then. */
export interface OrderSuccessState {
    productIds: number[];
    productNames: string[];
    email: string | null;
}

/**
 * After the order: what happens next (the same as the confirmation email says), and an
 * optional email reminder for when the products run out.
 */
@Component({
    selector: 'app-order-success',
    standalone: true,
    imports: [ReactiveFormsModule, RouterLink],
    templateUrl: './order-success.component.html'
})
export class OrderSuccessComponent implements OnInit {

    readonly deliveryTime = DELIVERY_TIME_TEXT;

    /** Null when the page is opened directly (a refresh, a bookmark) - then there is nothing to remind of. */
    order: OrderSuccessState | null = null;

    readonly reminderOptions = [
        {days: 14, label: 'за 2 недели'},
        {days: 21, label: 'за 3 недели'},
        {days: 30, label: 'за 1 месец'}
    ];

    reminderForm = new FormGroup({
        email: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.email]}),
        days: new FormControl(21, {nonNullable: true}),
        website: new FormControl('', {nonNullable: true})
    });

    sending = false;

    reminderSet = false;

    reminderFailed = false;

    constructor(private readonly router: Router,
                private readonly http: HttpClient) {
        this.order = (this.router.getCurrentNavigation()?.extras.state as OrderSuccessState | undefined) ?? null;
    }

    ngOnInit(): void {
        if (this.order?.email) {
            this.reminderForm.controls.email.setValue(this.order.email);
        }
    }

    get reminderLabel(): string {
        const days = Number(this.reminderForm.controls.days.value);
        return this.reminderOptions.find(option => option.days === days)?.label ?? '';
    }

    get productsText(): string {
        return (this.order?.productNames ?? []).map(name => name.split('|')[0].trim()).join(', ');
    }

    setReminder(): void {
        if (!this.order || this.reminderForm.invalid || this.sending) {
            this.reminderForm.markAllAsTouched();
            return;
        }
        const value = this.reminderForm.getRawValue();
        this.sending = true;
        this.reminderFailed = false;
        this.http.post<void>(environment.domain.backend + '/reminders', {
            email: value.email.trim(),
            productIds: this.order.productIds,
            days: Number(value.days),
            website: value.website
        }).subscribe({
            next: () => {
                this.sending = false;
                this.reminderSet = true;
            },
            error: () => {
                this.sending = false;
                this.reminderFailed = true;
            }
        });
    }
}
